import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sanju/Desktop/office project/redcard/src/components/tour/TourPageClient.tsx");
